import React from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';
import { connect } from 'react-redux';
import { Dropdown, Menu } from 'antd';

const UserButton = ({id, $location, $rootScope}) => {

  const handleMenuClick = () => {
    $location.url('/logout');
    $rootScope.$apply();
  }

  const menuItems = [
    {
      key: 'logout',
      label: 'Logout',
      icon: <Icon type="sign-out" />
    }
  ]
  
  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleMenuClick
      }}
      placement="bottomLeft"
      trigger={['click']}
      overlayClassName="user-button"
    > 
      <ButtonContainer>
        <Icon type="user" />
        <Username>{id}</Username>
      </ButtonContainer>
    </Dropdown>
  )
}

const MenuText = styled.span`
  margin-left: 15px;
`

const ButtonContainer = styled.div`
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  float: right;
  text-transform: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-app-region: no-drag;
`

const Username = styled.div`
  margin-left: 10px;
  display: inline-block;
`

const mapStateToProps = state => { 
  const { id } = state.user;
  return { id };
};

export default connect(mapStateToProps)(UserButton);